import { render, staticRenderFns } from "./IdentifiedProblems.vue?vue&type=template&id=8aa969ac&scoped=true"
import script from "./IdentifiedProblems.vue?vue&type=script&lang=js"
export * from "./IdentifiedProblems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa969ac",
  null
  
)

export default component.exports